// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"9fe82e1262d54d04647a","293":"3f675795d7fe66dd4f91","522":"3c4a08b849f125ae369f"}[chunkId] + ".js";
};